import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

/** 指定方法 */
enum SpecificationMethod {
  selection = '0',
  input = '1',
}

const nameConfig = {
  selection: new Map([
    [Locale.ja, '選択指定'],
    [Locale.en, 'Specify Selection'],
  ]),
  input: new Map([
    [Locale.ja, '入力指定'],
    [Locale.en, 'Specify Input'],
  ]),
};

const toEnum = rawValueToEnum(SpecificationMethod, SpecificationMethod.input);
const toDisplay = enumToName(SpecificationMethod, nameConfig);
const toDisplayWithPrefix = enumToName(SpecificationMethod, nameConfig, { prefix: true });

export const specificationMethod = {
  enum: SpecificationMethod,
  nameConfig,
  toEnum,
  toDisplay,
  toDisplayWithPrefix,
};
export type { SpecificationMethod };
